import { employeeRolesEnum, roles } from '../assets/roles';

const { ADMIN } = roles;
const { COMPANY_OWNER, COMPANY_ADMIN } = employeeRolesEnum;

class RolePermissionsHelper {
  canEditMember(memberRole?: employeeRolesEnum) {
    switch (memberRole) {
      case COMPANY_OWNER:
      case COMPANY_ADMIN:
        return true;
      default:
        return false;
    }
  }

  canSeeCommissions(memberRole: employeeRolesEnum) {
    return [COMPANY_OWNER, COMPANY_ADMIN].includes(memberRole);
  }

  canSeeRates(memberRole: employeeRolesEnum) {
    return [COMPANY_OWNER, COMPANY_ADMIN].includes(memberRole);
  }

  canResetPassword(userRole: string) {
    switch (userRole) {
      case ADMIN:
        return true;
      default:
        return false;
    }
  }

  canInviteMembers(memberRole: employeeRolesEnum) {
    return [COMPANY_OWNER, COMPANY_ADMIN].includes(memberRole);
  }

  canEditTeam(userTeamRole: string) {
    return userTeamRole === COMPANY_OWNER;
  }

  canEditEmployee(userTeamRole: string) {
    return userTeamRole === COMPANY_OWNER || userTeamRole === COMPANY_ADMIN;
  }

  canAccessSections(userRole?: string, teamRole?: string) {
    if (userRole === ADMIN || teamRole) {
      return ['candidates', 'vacancies', 'clients', 'reminders'];
    } else {
      return [];
    }
  }

  canCreateAndEditCandidate(memberRole: employeeRolesEnum) {
    return [COMPANY_OWNER, COMPANY_ADMIN].includes(memberRole);
  }
}

export const RolePermissions = new RolePermissionsHelper();
